





































































































































































































































































































































import TabsInfoMixin from '../../devices/TabsInfoMixin';
import Component from 'vue-class-component';
import { Mixins } from 'vue-mixin-decorator';
import { Watch, Prop } from 'vue-property-decorator';
import { Global, User } from '@/store';
import Utils from '@/modules/Utils';
import cloneDeep from 'lodash/cloneDeep';
import PropUtils from '@/modules/PropUtils';
// @ts-ignore
import VueQRCodeComponent from 'vue-qrcode-component';
import PropEditor from '@/components/PropEditor.vue';
import { Types } from '@/modules/API';
import moment from 'moment';
import OperationHistoryDialog from './components/OperationHistoryDialog.vue';
import { setOperationState, markDeviceAsRetrofit, canManageRetrofit, RETROFIT_STATE, PARTIAL_RETROFIT_STATE } from '@/modules/retrofitActions';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';
import LoadingDialog from '@/components/dialogs/LoadingDialog.vue';

@Component({ 
    components: {
        VueQRCodeComponent,
        PropEditor,
        OperationHistoryDialog,
        ConfirmDialog,
        LoadingDialog
    }
})

class AdvancedTab extends Mixins<TabsInfoMixin>(TabsInfoMixin) {
    @Global.State('readonly_user') readonly_user;
    @Global.State('lang') lang;
    @Global.State('timezone') projectTimezone;
    @User.State('role') role;
    @User.State('isManager') isManager;
    @User.State('username') username;

    // @ts-ignore
    @Prop() device;
    @Prop() mqtt;
    @Prop() deviceStreams;
    @Prop() streamActiveObject;
    @Prop() propsList;
    @Prop() outputs;
    @Prop() isCompulab;
    @Prop() liveReadingsAdvanced;
    @Prop() currentTime;
    @Prop() services_config;
    @Prop() services_config_status;
    @Prop() updateServiceStatus;
    @Prop() sys_active_modified;
    @Prop() connection_state;
    @Prop() mqtt_version;
    @Prop() electricity_price_prop;

    streamConnectedObject = null;
    sysConnectedChangeTime = null;
    sysActiveChangeTime = null;
    streamRssi = null;
    deviceVersion = null;
    services_status = {
        window: {start: '', end: ''},
        display_alerts_service: false,
        enabled_turn_off: false,
        alert_is_on: false,
        display_schedule_service: false,
        schedule_is_on: false,
        display_cabinet_iq_service: false,
        cabinet_iq_is_on: false
    };
    loading = true;
    qrcode = '';
    size = 130;
    operation_state = '';
    fixtures_confirm_dialog = false;
    fixtures_update_loading = false;
    retrofit_loading = false;
    pending_fixtures_count = 0;
    tariff_type = '';
    tariff_tou = {
        tariff_1: 0,
        tariff_2: 0,
        tariff_3: 0
    };
    tariff_fixed = {
        tariff_1: 0,
        tariff_2: 0,
        tariff_3: 0
    };
    max_daily_consumption = null;
    utils_module = Utils;
    operation_history_dialog = false;
    $refs!: { propEditor: InstanceType<typeof PropEditor> };

    openIcon = require('@/assets/images/cabinet_details_icons/open_switch.jpeg');
    closeIcon = require('@/assets/images/cabinet_details_icons/closed_switch.jpeg');

    mounted() {
        this.loading = true;
        this.setProperties();
        this.services_status = cloneDeep(this.services_config_status);
        if (this.services_config && this.services_config.alerts && this.services_config.alerts.cabinet_daily_max_current_consumption_ampere) {
            this.max_daily_consumption = +this.services_config.alerts.cabinet_daily_max_current_consumption_ampere;
        }
        this.generateQRcode();
        if (this.effective_operation_state_value) {
            this.operation_state = this.effective_operation_state_value.cabinet_opstate;
        }
        if (this.electricity_price_prop) {
            this.tariff_type = this.electricity_price_prop.type;
            if (this.tariff_type === 'fixed') {
                this.tariff_fixed.tariff_1 = this.electricity_price_prop.tariff_1;
            }else {
                this.tariff_tou.tariff_1 = this.electricity_price_prop.tariff_1;
                this.tariff_tou.tariff_2 = this.electricity_price_prop.tariff_2;
                this.tariff_tou.tariff_3 = this.electricity_price_prop.tariff_3;
            }
        }
        this.loading = false;
    }

    // services_status is a local clone taken on mount, so it has to be re-synced
    // when the services are switched from outside this tab - e.g. marking the
    // cabinet as Retrofit, which writes services.config and updates the status.
    @Watch('services_config_status', { deep: true })
    onServicesConfigStatusChange(status) {
        this.services_status = cloneDeep(status);
    }

    get is_manager(){
        return this.role === 'CA' || this.isManager;
    }

    // Read straight off the device row, the single source of truth for this state -
    // every writer mirrors into it and every fetch is committed to it, so there is no
    // second copy to reconcile with.
    get effective_operation_state_value() {
        return Utils.getOperationStateValue(this.device);
    }

    get effective_operation_state() {
        const value = this.effective_operation_state_value;
        return (value && (value.cabinet_opstate || value.state)) || '';
    }

    // Entering Retrofit turns the 2 alert services off (see retrofitActions.ts).
    // They must stay off for as long as the cabinet is under Retrofit - returning
    // it to another state is what re-enables the switches. Partial Retrofit leaves
    // them alone, so they stay editable there.
    get services_locked_by_retrofit() {
        return this.effective_operation_state === RETROFIT_STATE;
    }

    // The Power / schedule validation service is the opposite case: both Retrofit
    // and Partial Retrofit turn it ON and rely on it staying on, so its switch is
    // locked in both states - the user must not be able to turn it off.
    get schedule_service_locked_by_retrofit() {
        const operation_state = this.effective_operation_state;
        return operation_state === RETROFIT_STATE || operation_state === PARTIAL_RETROFIT_STATE;
    }

    get services_lock_reason() {
        return this.$t('Services are disabled while the cabinet is under Retrofit');
    }

    get schedule_lock_reason() {
        return this.$t('The power service stays on while the cabinet is under Retrofit');
    }

    // In full Retrofit both locks apply and the broader reason is the useful one;
    // in Partial Retrofit only the power service is locked.
    get services_lock_tooltip() {
        return this.services_locked_by_retrofit ? this.services_lock_reason : this.schedule_lock_reason;
    }

    // `pointer-events: none` blocks the mouse but the switch is still reachable by
    // keyboard, so a locked service is reverted here instead of being written.
    onScheduleServiceChange() {
        if (this.schedule_service_locked_by_retrofit) {
            this.services_status.schedule_is_on = this.services_config_status.schedule_is_on;
            return;
        }
        this.updateServiceStatus('schedules', this.services_status);
    }

    // Map-wide "see-through" toggle (GMap.vue toggleRetrofitSeeThrough) -
    // while on, the real connectivity values are unlocked.
    get retrofit_see_through() {
        return this.$store.state.MapSettings.retrofitSeeThrough;
    }

    // Connection / active status and RSSI reflect real-world connectivity, which is
    // meaningless only while the controller itself is out for Retrofit - so they're
    // hidden in full Retrofit alone (unless see-through mode is on).
    //
    // Partial Retrofit deliberately keeps them: the controller is installed and
    // communicating, just some of its fixtures are out. Same rule as the page
    // header's Connected/Disconnected chip (CabinetDetails.display_connection_state),
    // which the tab used to contradict.
    get retrofit_data_hidden() {
        return this.effective_operation_state === RETROFIT_STATE && !this.retrofit_see_through;
    }

    get show_operation_history() {
        return this.role === 'CA' || this.role === 'CM';
    }

    get cabinet_fixtures() {
        return this.$store.getters['Reports/cabinets_fixtures'].get(this.device.id) || [];
    }

    /**
     * Retrofit normally reaches a cabinet through the map's polygon selection - either the
     * controller is part of the batch, or the state is derived from its fixtures. A cabinet
     * with no commissioned fixtures has nothing to derive it from, so for that case only,
     * selecting it here directly is the sole way in.
     *
     * Partial Retrofit stays unselectable regardless: it's a cabinet-only state meaning
     * "some fixtures are under Retrofit", derived by the polygon flow's reconciliation and
     * meaningless with no fixtures at all.
     */
    get can_select_retrofit() {
        return canManageRetrofit() && !this.cabinet_fixtures.length;
    }

    get operation_states(){
        return [
            {
                text: this.$t('Installing'),
                value: 'installing'
            },
            {
                text: this.$t('Operational'),
                value: 'delivered'
            },
            {
                text: this.$t('Retrofit'),
                value: 'retrofit',
                disabled: !this.can_select_retrofit
            },
            {
                text: this.$t('Partial Retrofit'),
                value: 'partial_retrofit',
                disabled: true
            }
        ];
    }

    get tariff_options(){
        return [
            {
                text: this.$t('Fixed'),
                value: 'fixed'
            },
            {
                text: this.$t('TOU'),
                value: 'tou'
            }
        ];
    }

    get disabled_update_tariff(){
        return this.tariff_type === 'fixed' 
            ? this.tariff_fixed.tariff_1 !== 0 && !Number(this.tariff_fixed.tariff_1)
            : (this.tariff_tou.tariff_1 !== 0 && !Number(this.tariff_tou.tariff_1) ||
                this.tariff_tou.tariff_2 !== 0 && !Number(this.tariff_tou.tariff_2) || 
                this.tariff_tou.tariff_3 !== 0 && !Number(this.tariff_tou.tariff_3));

    }

    updateTariffData(){
        const prop = {
          name: 'electricity.price',
          objectID: this.device.id,
          objectType: Types.DEVICES
        };
        
        const electricity_tariff_to_server = this.tariff_type === 'fixed'
            ? { type: 'fixed', ...this.tariff_fixed }
            : { type: 'tou', ...this.tariff_tou };

        this.$refs.propEditor.save(
          electricity_tariff_to_server,
          prop,
          () => {
            this.$emit('updateTariffData', electricity_tariff_to_server);
          },
          'Cabinet tariff updated successfully'
        );
    }

    updateMaxDailyConsumption() {
        const prop = {
          name: 'services.config',
          objectID: this.device.id,
          objectType: Types.DEVICES
        };
        
        const alerts_config = this.services_config.alerts || {};
        const services_config_to_server = {
            ...this.services_config,
            alerts: {
                ...alerts_config,
                cabinet_daily_max_current_consumption_ampere: +this.max_daily_consumption
            }
        };

        this.$refs.propEditor.save(
          services_config_to_server,
          prop,
          () => {
            this.$emit('updateServicesConfig', services_config_to_server);
          },
          'Max daily consumption updated successfully'
        );
    }

    isRetrofitDerivedState(operation_state) {
        // Retrofit / Partial Retrofit are derived automatically from the cabinet's
        // fixtures (see retrofitActions.ts reconciliation) and are not selectable
        // here, so fixture propagation only ever applies to manually-selectable states.
        return [RETROFIT_STATE, PARTIAL_RETROFIT_STATE].includes(operation_state);
    }

    get fixtures_confirm_text() {
        const target_state = this.operation_states.find((state) => state.value === this.operation_state);
        const target_label = target_state ? target_state.text : this.operation_state;
        return `${this.pending_fixtures_count} ${this.$t('fixtures under this cabinet will be updated to')} ${target_label}.`;
    }

    updateOperationState(){
        // Entering Retrofit is more than a property write, so it runs retrofitActions'
        // markDeviceAsRetrofit - the very same per-device sequence the map's polygon
        // selection runs (runRetrofitBatch -> runDeviceRetrofitSequence), so the two entry
        // points can't drift apart. Everything below stays a plain property save.
        if (this.operation_state === RETROFIT_STATE) {
            this.markCabinetAsRetrofit();
            return;
        }

        const fixtures = this.cabinet_fixtures;
        const should_confirm = !this.isRetrofitDerivedState(this.operation_state) && fixtures.length > 0;

        if (should_confirm) {
            this.pending_fixtures_count = fixtures.length;
            this.fixtures_confirm_dialog = true;
            return;
        }

        this.saveOperationState();
    }

    async markCabinetAsRetrofit(){
        this.retrofit_loading = true;
        const result = await markDeviceAsRetrofit(this.device);
        this.retrofit_loading = false;

        if (result.status !== 'success') {
            // Reset the select to the state the cabinet is actually in, so a failed
            // attempt doesn't leave the UI claiming it's under Retrofit.
            this.operation_state = this.effective_operation_state;
            this.$store.dispatch('Global/throwNotify', {
                type: 'error',
                title: `${this.$t('Error')}!`,
                text: result.reason || this.$t('Operation state was not updated')
            });
            return;
        }

        // markDeviceAsRetrofit mirrors every write into the device row, so the value the
        // parent needs is already there - no second source to build it from.
        this.$emit('updateOperationState', this.effective_operation_state_value);
        this.$store.dispatch('Global/throwNotify', {
            type: 'success',
            title: this.$t('Success'),
            text: this.$t('Operation state updated successfully')
        });
    }

    confirmFixturesUpdate() {
        this.fixtures_confirm_dialog = false;
        this.saveOperationState();
    }

    saveOperationState(){
        const prop = {
          name: 'cabinet.operation_state',
          objectID: this.device.id,
          objectType: Types.DEVICES
        };

        let last_change = moment().utcOffset(0).valueOf(); // milliseconds
        last_change = Math.floor(last_change / 1000); // seconds
        
        const operation_state_to_server = {
            cabinet_opstate: this.operation_state,
            updater: this.username,
            date: last_change
        };

        this.$refs.propEditor.save(
          operation_state_to_server,
          prop,
          () => {
            this.$emit('updateOperationState', operation_state_to_server);
            this.propagateOperationStateToFixtures(this.operation_state);
          },
          'Operation state updated successfully'
        );
    }

    async propagateOperationStateToFixtures(operation_state) {
        if (this.isRetrofitDerivedState(operation_state)) {
            return;
        }

        const fixtures = this.cabinet_fixtures;
        if (!fixtures.length) {
            return;
        }

        this.fixtures_update_loading = true;
        try {
            await Promise.all(fixtures.map((fixture) => setOperationState(fixture, operation_state)));
        } finally {
            this.fixtures_update_loading = false;
        }
    }

    validateMinValue(prop_name: string, inner_field?: string){
        if (inner_field) {
            if (+this[prop_name][inner_field] < 0) {
                this[prop_name][inner_field] = Math.abs(+this[prop_name][inner_field]);
            }
        }else if (+this[prop_name] < 0) {
            this[prop_name] = Math.abs(+this[prop_name]);
        }
    }

    generateQRcode(){
        if (this.device.class_name.includes('sbc_cabinet')){
            this.qrcode = PropUtils.getTeltonicaHardwareid(this.device);
        }else {
            const hardwareidProp = this.device['device.hardwareid'];
            this.qrcode = hardwareidProp && hardwareidProp.id ? hardwareidProp.id : '';
        }
    }


    setProperties() {
        const deviceVersion = this.propsList.results.find((el) => el.name === 'device.version');
        this.deviceVersion = deviceVersion ? deviceVersion.value : null;
    }

    getLastRssi(){
        return this.device.rssi !== null && this.device.rssi !== undefined ? `${this.device.rssi} [dBm]` : this.$t('N/A');
    }

    getLocation(){
        return this.device.has_valid_location
            ? `${this.device['meta.location'].lat.toFixed(3)}, ${this.device['meta.location'].lng.toFixed(3)}`
            : this.$t('N/A');
    }

    getActiveStatus(){
        const modified_text = this.sys_active_modified ? `${this.$t('since')} ${this.sys_active_modified}` : '';
        if (this.sys_active_modified === undefined || this.sys_active_modified === null) return this.$t('N/A');

        // Through the shared resolver: -4 is truthy, so it used to read as "Active"
        // here, and it only means Pending Verification once the cabinet has actually
        // been returned from Retrofit (Utils.isPendingVerification).
        return `${Utils.getActiveStatusLabel(this.device)} ${modified_text}`;
    }

    getCreationDate() {
        return this.device.created_ts 
            ? this.getTimezoneDate(this.device.created_ts)
            : 'N/A';
    }

    getTimezoneDate(timestamp){
        return Utils.convertTimestamp(timestamp * 1000, 'DD/MM/YYYY HH:ss', this.projectTimezone);
    }

    getLiveData() {
        this.publishMqttMessage('-1', 'control');
        this.publishMqttMessage('-1', 'digital_input');
        this.publishMqttMessage('-1', 'live_data');
    }

    publishMqttMessage(message, streamName) {
        const mqtt_publish_data = {
            version_num: this.mqtt_version,
            device_id: this.device.id,
            stream_id: this.mqtt_version === 3 ? `${this.device.id}.${streamName}` : streamName,
            message_type: 'cmd',
            format: 'minimal',
            stream_value: message,
            options: {
                retain: false,
                qos: 1
            }
        };

        this.mqtt.publishToSingleDevice(mqtt_publish_data);
    }

}

export default AdvancedTab;
